import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { registerSW } from 'virtual:pwa-register'
import App from './App'
import { useChallengeStore } from './store/challengeStore'
import { useProgressStore } from './store/progressStore'
import { useSessionStore } from './store/sessionStore'
import './styles/global.css'

// El panel del entrenador no lo abre ningún alumno: se descarga aparte y solo
// cuando hace falta, para no engordar la app que se usa entrenando.
const AdminScreen = lazy(() =>
  import('./features/admin/AdminScreen').then((module) => ({ default: module.AdminScreen })),
)

const container = document.getElementById('root')
if (!container) throw new Error('Falta el contenedor #root')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route
          path="/admin"
          element={
            <Suspense fallback={null}>
              <AdminScreen />
            </Suspense>
          }
        />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)

// La app se actualiza sola en cuanto hay versión nueva: los alumnos no tienen
// que hacer nada para recibir los entrenos de la semana siguiente.
registerSW({ immediate: true })

// En desarrollo, los almacenes quedan a mano desde la consola para poder
// saltar a cualquier bloque sin cronometrar el entreno entero.
if (import.meta.env.DEV) {
  Object.assign(window, {
    tfc: { session: useSessionStore, progress: useProgressStore, challenge: useChallengeStore },
  })
}
